<template>
  <div class="common-ui">
    <error-modal
      modal-id="fatal-error"
      :title="fatal.title"
      :message="fatal.msg"
    >
    </error-modal>

    <b-modal
      id="modal-login"
      title="Log in to your Jeroboams account"
      @ok="doLogin"
      :busy="loginBusy"
    >
      <login-form
        ref="login-form"
        @busy="loginBusy = $event.target.value"
      ></login-form>
    </b-modal>

    <b-modal id="modal-basket-expiring-soon-30" title="Basket expires soon">
      <p>Your basket will expire in less than 30 minutes.</p>
      <p>
        In order to complete your purchase, please check out within 30 minutes
        or less.
      </p>
    </b-modal>

    <b-modal id="modal-basket-expiring-soon-10" title="Basket expires soon">
      <p>Your basket will expire in less than 10 minutes.</p>
      <p>
        In order to complete your purchase, please check out within 10 minutes
        or less.
      </p>
    </b-modal>

    <b-modal id="modal-basket-expired" title="Basket expired">
      <p>Your basket has now expired.</p>
    </b-modal>
  </div>
</template>

<script>
/* global wpConfig */
/* global _WINELIST */
/* global _WISHLIST */
/* global _BASKET */

import Inflector from "inflector-js";

import ErrorModal from "@/components/ErrorModal";
import Latch from "@/modules/notify-latch";
import LoginForm from "@/components/LoginForm";

export default {
  data() {
    return {
      loginBusy: false,
      fatal: {
        title: "",
        msg: "",
        err: false,
      },
    };
  },
  components: {
    ErrorModal,
    LoginForm,
  },
  mounted() {
    window.addEventListener("login-modal", this.showLoginModal);
    window.addEventListener("notices", this.handleNotices);
    window.addEventListener("fatal", this.handleFatal);
    this.$store.commit("user/update", wpConfig.user);

    this.$root.$on("basket-expiring-soon-30", this.showBasketExpiringModal30);
    this.$root.$on("basket-expiring-soon-10", this.showBasketExpiringModal10);
    this.$root.$on("basket-expired", this.showBasketExpired);

    window.dispatchEvent(
      new CustomEvent("notices", {
        detail: wpConfig.notices,
      })
    );

    if (
      process.env.JBS_SITEMODE === "trade" &&
      typeof _WINELIST !== "undefined"
    ) {
      this.$store.commit("winelist/update_lists", _WINELIST);
    } else {
      if(_BASKET)
        this.$store.commit("basket/update", _BASKET);
      
      if (
        this.$store.state.basket.allocated &&
        !this.$store.state.basket.reserved &&
        Object.keys(this.$store.state.basket.items).length > 0
      ) {
        this.$store.dispatch("basket/poll_until_reserved");
      }
      this.$store.commit("readiness/is_ready", "basket");

      if(_WISHLIST)
        this.$store.commit("wishlist/update", _WISHLIST);
    }
  },
  destroyed() {
    window.removeEventListener("login-modal", this.showLoginModal, false);
    window.removeEventListener("notices", this.handleNotices, false);
    window.removeEventListener("fatal", this.handleFatal, false);
  },
  methods: {
    doLogin(evt) {
      evt.preventDefault();
      this.$refs["login-form"].doLogin().then((response) => {
        if (response.data.status) {
          this.$bvModal.hide("modal-login");
          location.reload();
        }
      });
    },
    showLoginModal() {
      this.$bvModal.show("modal-login");
    },
    showBasketExpiringModal30() {
      if (!Latch.has("basket-expiring-soon-30")) {
        this.$bvModal.show("modal-basket-expiring-soon-30");
        Latch.did("basket-expiring-soon-30");
      }
    },
    showBasketExpiringModal10() {
      if (!Latch.has("basket-expiring-soon-10")) {
        this.$bvModal.show("modal-basket-expiring-soon-10");
        Latch.did("basket-expiring-soon-10");
      }
    },
    showBasketExpired() {
      if (!Latch.has("basket-expired")) {
        this.$bvModal.show("modal-basket-expired");
        Latch.did("basket-expired");

        this.$store.dispatch("basket/refresh_state").then(() => {
          Latch.reset("basket-expiring-soon-10");
          Latch.reset("basket-expiring-soon-30");
          Latch.reset("basket-expired");
        });
      }
    },
    handleFatal(evt) {
      this.fatal.title = evt.detail.title;
      this.fatal.msg = evt.detail.msg;
      this.fatal.err = evt.detail.err ?? false;

      this.$bvModal.show("fatal-error");
    },
    handleNotices(evt) {
      var notices = evt.detail;
      for (var level in notices) {
        var variant = "success";
        var title = "Information";

        switch (level) {
          case "error":
            variant = "danger";
            break;
          case "notice":
            variant = "info";
            break;
        }

        const htmlDecode = function (input) {
          var doc = new DOMParser().parseFromString(input, "text/html");
          return doc.documentElement.textContent;
        };

        for (var i in notices[level]) {
          this.$bvToast.toast(
            htmlDecode(notices[level][i].notice.replace(/(<([^>]+)>)/gi, "")),
            {
              title: Inflector.humanize(title),
              toaster: "b-toaster-bottom-left",
              autoHideDelay: level === "success" ? 4500 : 7000,
              variant,
              solid: false,
              appendToast: false,
            }
          );
        }
      }
    },
  },
};
</script>